import moment from "moment";
import React, { useContext, useRef, useState } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Select from "react-select";
import "./ManagerReportsStyle.css";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { getWatchlistNumber } from "../../../services/chartService";
import { useLocation } from "react-router-dom";
import AuthContext from "../../Auth/Middleware/AuthContext";

const FilterSection = ({
  filterOptionsLoading,
  filtersOptions,
  data,
  onFilterChange,
  filterFields,
  onFilterClick,
  setIsAuditDoneDateSelected,
}) => {
  const routeLocation = useLocation();
  const authContext = useContext(AuthContext);
  const [optionsWorklist, setOptionsWorklist] = useState([]);
  const [selectedOptionWorkListActual, setSelectedOptionWorkListActual] =
    useState([]);
  const [, setSelectedOptionsChart] = useState([
    routeLocation?.state?.submitData?.chart_no ?? "",
  ]);
  const [selectedOptionChartRender, setSelectedOptionChartRender] = useState(
    [],
  );
  const [optionsChart, setOptionsChart] = useState([]);
  const typeaheadRef = useRef(null);
  const typeheadRefChart = useRef(null);
  const [, setSelectedOptionWorkList] = useState([]);
  const getType = (val) => {
    if (val) {
      if (val.toLowerCase() === "integer") {
        return "number";
      }
      if (val.toLowerCase() === "string") {
        return "text";
      }
      return val;
    }
  };

  const handleSearchWorkList = async (query) => {
    let postData = {
      worklist_no: query,
      chart_no: "",
    };

    const items = await getWatchlistNumber(postData);
    const workList = items?.data?.typeaheadWorkListRecord;
    setOptionsWorklist(workList);
    setSelectedOptionWorkList(query);
  };
  const handleSearchChart = async (query) => {
    let postData = {
      worklist_no: "",
      chart_no: query,
    };
    const items = await getWatchlistNumber(postData);
    const chart = items?.data?.typeaheadChartRecord;
    setOptionsChart(chart);
    setSelectedOptionsChart(query);
  };
  const getFilterData = () => {
    let tempFilterFields = [];
    let currentDate = new Date();
    let currentMonth = currentDate.getMonth();
    for (let a in filterFields) {
      let item = filterFields[a];
      let options = [];
      if (filtersOptions[a]) {
        if (item.filterType === "select") {
          item.disabled = false;
          filtersOptions[a].forEach((item) => {
            options.push({
              label: item.name,
              value: item.id,
            });
          });
          if (item.label === "QC Status") {
            options.push({
              label: "Blank",
              value: 0,
            });
          }
          if(item.label === "Client" && authContext.globalClientId){
            const client = authContext.globalClientId?.value;
            if(+client && options?.length > 0) {
              const selectedClientObj = options.filter((clInFilter) => clInFilter.value === +client);
              item.value = [...selectedClientObj];
              item.disabled = true;
            } else {
              item.disabled = false;
              delete item.value
            }
          }
          if(item.label === "Location" && authContext.globalLocationId){
            const locationProcess = authContext.globalLocationId?.value?.split('_');
            if(Array.isArray(locationProcess) && locationProcess[0] === 'location' && options?.length > 0) {
              const selectedLocationObj = options.filter((location)=>location.value === +locationProcess[1]);
              if(selectedLocationObj[0]){
                item.value = [{label: selectedLocationObj[0].label, value: selectedLocationObj[0].value}];
                item.disabled = true;
              }
            } else if(Array.isArray(locationProcess) && locationProcess[0] === 'process') {
              // item.disabled = true;
              // item.value = [];
            } else {
              item.disabled = false;
            }
          }
          if(item.label === "Process" && authContext.globalLocationId){
            const locationProcess = authContext.globalLocationId?.value?.split('_');
            if(Array.isArray(locationProcess) && locationProcess[0] === 'location' && options?.length > 0) {
              const selectedLocationObj = options.filter((location)=>location.value === +locationProcess[1]);
              if(selectedLocationObj[0]){
                item.value = [{label: selectedLocationObj[0].label, value: selectedLocationObj[0].value}];
                item.disabled = true;
              }
            } else if(Array.isArray(locationProcess) && locationProcess[0] === 'process') {
              item.disabled = true;
              item.value = [];
            } else {
              delete item.value
            }
          }
        }
      }
      
      tempFilterFields.push(
        <div key={item.label} className="col-lg-3 ">
          <label className="form-label w-250px">{item.label} </label>
          {
            (item.filterType === "date" && (item.label === "Audit Done Milestone Date" || item.label === "Date of Coding") )&& (
            <DateRangePicker
              onApply={(e, j) => {
                const start = moment(j.startDate);
                const end = moment(j.endDate);

                if (end.diff(start, "days") > 1) {
                  handleDatePickerCancel("", a);
                  setIsAuditDoneDateSelected((prev) => ({
                    auditDoneMilestoneDate: item.label === "Audit Done Milestone Date" ? true : prev.auditDoneMilestoneDate,
                    dateOfCoding: item.label === "Date of Coding" ? true : prev.dateOfCoding,
                  }));
                }else{
                  setIsAuditDoneDateSelected((prev) => ({
                    auditDoneMilestoneDate: item.label === "Audit Done Milestone Date" ? false : prev.auditDoneMilestoneDate,
                    dateOfCoding: item.label === "Date of Coding" ? false : prev.dateOfCoding,
                  }));
                }

                onFilterChange(
                  `${start.format("L")}-${end.format("L")}`,
                  a
                );
              }}
              initialSettings={{
                startDate: new Date(),
                endDate: moment().add(1, "days").toDate(),
                maxDate: new Date(currentDate.getFullYear(), currentMonth + 1, 0),
                locale: { cancelLabel: "Clear" },
              }}
                onCancel={() => {
                  setIsAuditDoneDateSelected((prev) => ({
                    auditDoneMilestoneDate: item.label === "Audit Done Milestone Date" ? false : prev.auditDoneMilestoneDate,
                    dateOfCoding: item.label === "Date of Coding" ? false : prev.dateOfCoding,
                  }));
                handleDatePickerCancel("", a);
              }}
            >
              <p className="form-control text-sm-left">
                {filterFields[a].value ? filterFields[a].value : `Select date`}
              </p>
            </DateRangePicker>)
          }
          {item.filterType === "select" ? (
            <Select
              isLoading={filterOptionsLoading}
              name="colors"
              className="filterSelect"
              classNamePrefix="select"
              value={item.value}
              options={options}
              isMulti={item.multiselect}
              onChange={(e) => {
                onFilterChange(e, a);
              }}
              isDisabled={item.disabled}
              isClearable={true}
            />
          ) : (item.filterType === "date" && (item.label !== "Audit Done Milestone Date" && item.label !== "Date of Coding") ) ? (
            <DateRangePicker
              onApply={(e, j) => {
                onFilterChange(
                  `${moment(j.startDate).format("L")}-${moment(
                    j.endDate,
                  ).format("L")}`,
                  a,
                );
              }}
              initialSettings={{
                startDate: new Date(),
                endDate: new Date(),
                maxDate: new Date(
                  currentDate.getFullYear(),
                  currentMonth + 1,
                  0,
                ),
                locale: { cancelLabel: "Clear" },
              }}
              onCancel={() => {
                handleDatePickerCancel("", a);
              }}
            >
              <p className="form-control text-sm-left">
                {filterFields[a].value ? filterFields[a].value : `Select date`}
              </p>
            </DateRangePicker>
          ) : item.label === "Worklist number" ? (
            <AsyncTypeahead
              id="worklistdata"
              labelKey="worklist_no"
              placeholder="..."
              options={optionsWorklist}
              useCache={false}
              debounceTime
              minLength={1}
              onSearch={handleSearchWorkList}
              renderMenuItemChildren={(option) => (
                <>
                  {" "}
                  <span>{option.worklist_no}</span>{" "}
                </>
              )}
              selected={selectedOptionWorkListActual}
              ref={typeaheadRef}
              onChange={(selected) => {
                setSelectedOptionWorkListActual(selected);
                setSelectedOptionWorkList([selected[0]?.worklist_no]);
                const selectedWorklistNo =
                  selected.length > 0 ? selected[0].worklist_no : "";
                onFilterChange(selectedWorklistNo, a);
              }}
            />
          ) : item.label === "Chart Number" ? (
            <AsyncTypeahead
              filterBy={() => true}
              id="chartdata"
              labelKey="chart_no"
              placeholder="..."
              options={optionsChart}
              ref={typeheadRefChart}
              useCache={false}
              debounceTime
              onSearch={handleSearchChart}
              selected={selectedOptionChartRender}
              minLength={1}
              onChange={(selected) => {
                setSelectedOptionChartRender(selected);
                setSelectedOptionsChart(selected[0]?.chart_no || "");
                const selectedChartNo =
                  selected.length > 0 ? selected[0].chart_no : "";
                onFilterChange(selectedChartNo, a);
              }}
            />
          ) : (item.label === "Audit Done Milestone Date" || item.label === "Date of Coding")? null : (
            <input
              min={item.min ?? null}
              max={item.max ?? null}
              type={getType(item.type)}
              value={filterFields[a].value}
              className="form-control "
              onChange={(e) => {
                let value = e.target.value;
                if (
                  item.type.toLowerCase() === "integer" ||
                  item.type.toLowerCase() === "number"
                )
                  value = parseInt(e.target.value);
                onFilterChange(value, a);
              }}
              placeholder=""
            />
          )}
        </div>,
      );
    }
    return tempFilterFields;
  };
  const handleDatePickerCancel = (value, fieldName) => {
    onFilterChange(value, fieldName);
  };

  return (
    filterOptionsLoading ? <div className="d-flex justify-content-center pb-20">
    <div className="spinner-border text-primary d-flex justify-content-center" role="status" >
      <span className="sr-only">Loading...</span>
    </div></div> :
    <div className="card-body border-0 py-0 minimize reports-filter-section">
      {Object.keys(filterFields).length > 0 ? (
        <>
          <div className="row mb-5 horizontal-scrollable">
            {getFilterData()}
          </div>{" "}
          <div className="d-flex justify-content-end p-5 ">
            <button onClick={onFilterClick} className="btn btn-primary fs-6">
              Filter
            </button>
          </div>
        </>
      ) : (
        <div className="d-flex justify-content-center pb-20">
          No Filters Selected
        </div>
      )}
    </div>
  );
};
export default FilterSection;
